// src/app/core/interceptors/delegation.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DelegationTokenService } from '@core/auth/delegation-token.service';

@Injectable()
export class DelegationInterceptor implements HttpInterceptor {
  
  constructor(private delegationTokenService: DelegationTokenService) {}
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.delegationTokenService.isDelegatingSync()) {
      const delegationId = this.delegationTokenService.getDelegationId();

      if (delegationId) {
        // Le backend (JwtAuthenticationFilter) applique l'identite et les droits du delegant
        const delegationRequest = req.clone({
          setHeaders: {
            'X-Delegation': delegationId
          }
        });
        
        return next.handle(delegationRequest);
      }
    }
    
    return next.handle(req);
  }
}
